/*
|--------------------------------------------------------------------------
| Buckets
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */

__gh__webApp.buckets = {

	/**
	 * Initialize buckets
	 */
	"init": function(){
		__gh__coreData.globalVariables 			= __gh__coreData.globalVariables || {};
		__gh__coreData.globalVariables.buckets 	= {"totalBucketsProcessed":0};
		var buckets 							= __gh__coreData.pageData.buckets;

		//If there are no buckets to load, remove loading gifs and end the function
		if(buckets && !buckets.length){this.removeLoadingGifs();return;}

		this.injectListeners(buckets.length);
		this.bindEvents();
		this.loadBuckets({"start":0,"end":3});
	},

	"injectListeners": function(totalBuckets){
		var injectView = __gh__webApp.utilities.fetch.handlebarsView.append;
			injectView({
				"dom":"#buckets",
				"view":"buckets/partials/listeners/_loadBuckets",
				"data":{"totalBuckets":totalBuckets}
			});
	},

	"removeLoadingGifs": function(){
		$('section.loading').remove();
		$('article.loading').remove();
	},

	"fetchJSONCallback": function(data){
		var thisObject				= __gh__webApp.buckets,
			validateBucket			= __gh__webApp.data.validate.bucket,
			injectView				= __gh__webApp.utilities.fetch.handlebarsView.after,
			currentPage				= __gh__webApp.currentPage,
			commonJS				= __gh__webApp.common,
			bucket					= data.bucket,
			items					= bucket.items,
			buckets					= __gh__coreData.pageData.buckets,
			totalBuckets			= buckets.length,
			i 						= data.index,
			listenerID				= data.listenerID,
			start					= data.start,
			jsonData				= ("json" in data) ? data.json : {},
			bucketHasItems			= false,
			totalBucketsProcessed	= __gh__coreData.globalVariables.buckets.totalBucketsProcessed;

		totalBucketsProcessed++;

		//Update bucket
		bucket.items 			= (validateBucket.hasItems(bucket)) ? bucket.items : jsonData;
		bucket.hasAd			= validateBucket.hasAd(bucket);
		bucketHasItems			= validateBucket.hasItems(bucket);
		bucket 					= ((!bucketHasItems && !bucket.feedURL) || bucketHasItems) ? thisObject.getSubView(bucket) : false;
		bucket.readMore 		= (i+1 == 1 && !currentPage.isHome()) ? false : true;
		bucket.titleTag			= ((i > 0 && !currentPage.isHome()) || currentPage.isHome()) ? 'h2' : 'h1';
		viewName				= (commonJS.isObjectPropertySet(bucket,"view.layout")) ? bucket.view.layout : "layouts/default";


		//Turn on the rest of the bucket listeners
		if(totalBucketsProcessed == 3){
			$(".turn-on-bucket-listener").attr("data-gh-buckets-load-more",true);
		}
		__gh__coreData.globalVariables.buckets.totalBucketsProcessed = totalBucketsProcessed;


		//Kill bucket check
		if(!bucket){
			__gh__coreData.pageData.buckets[i].killBucket = true;
			return;
		} else {

			bucket.killBucket					= false;
			__gh__coreData.pageData.buckets[i] 	= bucket;
		}

		//Append view to page
		injectView({"dom":listenerID,"view":viewName, "data":bucket});
		
		var removeLoadingGif = ("removeLoadingGif" in bucket);
		if (!removeLoadingGif || (removeLoadingGif && bucket.removeLoadingGif)) {
			thisObject.removeLoadingGifs();
		}
		
		//Trigger any post lay down functionality
		thisObject.triggerPostLaydownFunctions(bucket,start,i);


		//Turn off scroll listener
		if(totalBucketsProcessed == totalBuckets){
			$(document).off("scroll.gh-buckets-load-more");
		}

	},

	/**
	 * Load data
	 * Fetches the json feeds for the buckets
	 * @param {object} options
	 * @param {number} [options.start=0] - the index in the buckets array that we should start from
	 * @param {number} [options.end=options.start+3] - last bucket index to get
	 */

	"loadBuckets": function(options){
		var fetchJSON				= __gh__webApp.utilities.fetch.json.get,
			buckets 				= __gh__coreData.pageData.buckets,
			validateBucket			= __gh__webApp.data.validate.bucket,
			commonJS				= __gh__webApp.common,
			bucketsPerPage			= 1,
			start 					= (options.start) ? options.start : 0,
			end						= (options.end) ? options.end : start + bucketsPerPage,
			totalBuckets			= buckets.length,
			loadMoreCheck			= (totalBuckets > end) ? true : false,
			end						= (loadMoreCheck) ? end : totalBuckets,
			newStart				= (loadMoreCheck) ? end + 1 : false,
			killBucketIndex			= false;



		//Load bucket data
		for (i = start; i < end; i++) {
			var bucket 				= buckets[i],
				bucket 				= this.hookBeforeBucketHasItems(bucket),
				items				= bucket.items,
				feedURL				= bucket.feedURL,
				listenerID			= "#gh-buckets-listener-"+i
				callbackData		= {
					"bucket":bucket,
					"index":i,
					"listenerID":listenerID,
					"start":start
				},
				callbacks			= [{
					"callback": "__gh__webApp.buckets.fetchJSONCallback",
					"data": callbackData
				}];


			//Fetch content from feed and store in data node
			if(feedURL && !validateBucket.hasItems(bucket)){
				fetchJSON({
					"async"	: true,
					"url"	: feedURL,
					"callbacks": callbacks,
					"errorCallbacks": callbacks
				});

				continue;
			}

			this.fetchJSONCallback(callbackData);

	    }


	},


	/**
	 * Load more buckets
	 */
	"loadMore": function(){
		var $loadMore 	= $("[data-gh-buckets-load-more=true]").first(),
			buckets 	= __gh__coreData.pageData.buckets;

		//Check to see if load more data
		if ($loadMore.length){
	 		var options = $loadMore.data("gh-buckets-object");

	    	//Update load more attribute so content isn't loaded again
	    	$loadMore.attr("data-gh-buckets-load-more",false);

	    	//Load more views
	    	__gh__webApp.buckets.loadBuckets(options);
	        console.log('load more buckets...');
	    }
	},


	/**
	 * Load more views when the load more data attribute is on screen
	 */
	"loadMoreIfOnScreen": function(){
		var $loadMore 		= $("[data-gh-buckets-load-more=true]").first(),
			buckets 		= __gh__coreData.pageData.buckets,
			thisObject		= __gh__webApp.buckets;

		//Check to see if load more data
		if ($loadMore.length && $loadMore.isOnScreen(500)){
	 		thisObject.loadMore();
	 	}
	},


	/**
	 * Callback functions that are called after a bucket is layed down.
	 * It will attempt to look for views.[bucket].callbacks to load any call back functions for a view
	 */
	"triggerPostLaydownFunctions": function(bucket,start,i){
		var views 			= __gh__webApp.views,
			viewStaticName 	= bucket.view.staticName,
			currentPage 	= __gh__webApp.currentPage,
			utilities		= __gh__webApp.utilities;

		if(views[viewStaticName] && views[viewStaticName].callbacks){
			views[viewStaticName].callbacks(bucket);
		}

		// Global Post laydown functions go here
		utilities.lazyImages.loadAllImages();


		if(start==0 && !currentPage.isHome() && !currentPage.isWrapper()){
			__gh__webApp.ads.init();
		}
	},

	/**
	 * It will attempt to look for views.[bucket].getSubView to load any subViews or modify the bucket before its layed down.
	 */
	"getSubView": function(bucket){
		var views = __gh__webApp.views;
		if(views[bucket.view.name] && views[bucket.view.name].getSubView){
			return views[bucket.view.name].getSubView(bucket);
		}
		//Set default view path
		bucket.view.name 	= "buckets/"+bucket.view.name+"/default";
		return bucket;
	},

	/**
	 * It will attempt to look for views.[bucket].hookBeforeBucketHasItems to update the bucket before items are fetched.
	 */
	"hookBeforeBucketHasItems": function(bucket){
		var views 	= __gh__webApp.views,
			viewName = bucket.view.name;
		if(views[viewName] && "hookBeforeBucketHasItems" in views[viewName]){
			return views[viewName].hookBeforeBucketHasItems(bucket);
		}
		return bucket;
	},


	 /**
	 * Bind events for bucket laydown
	 */
	"bindEvents": function(){
		//Load more buckets on scroll
		$(document).on("scroll.gh-buckets-load-more",this.loadMoreIfOnScreen);
	}

};